<template>
  <div class="o-step">
    <div class="flex items-center">
      <div>
        <div :class="circleClass">
          <template v-if="isComplete || isSuccess">
            <o-icon icon="check" :size="12" fill />
          </template>
          <template v-if="isActive">
            <div class="bg-green-600 w-2 h-2 rounded-full" />
          </template>
        </div>
      </div>

      <div class="ml-4 w-full flex items-center justify-between">
        <div>
          <h3 v-if="name" :class="nameClass">
            {{ name }}
          </h3>
          <p v-if="info" class="text-gray-600 leading-none text-sm">
            {{ info }}
          </p>
        </div>

        <div>
          <slot name="control" />
        </div>
      </div>
    </div>
    <div class="flex items-stretch">
      <div :class="lineClass" />
      <div class="ml-4 mt-4 mb-8 w-full">
        <slot v-bind="slot" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      default: null
    },
    info: {
      type: String,
      default: null
    },
    success: {
      type: Boolean,
      default: false
    },
    danger: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      state: 'disabled'
    }
  },
  computed: {
    slot () {
      const { state, isActive, isDisabled, isComplete } = this
      return {
        state,
        isActive,
        isDisabled,
        isComplete
      }
    },
    isActive () {
      return this.state === 'active'
    },
    isDisabled () {
      return this.state === 'disabled'
    },
    isComplete () {
      return this.state === 'complete'
    },
    isSuccess () {
      return this.success
    },
    circleClass () {
      const classes = ['w-6 h-6 md:w-8 md:h-8 rounded-full inline-flex items-center justify-center select-none']

      if (this.isComplete) {
        classes.push('border-2 border-green-600 bg-green-600 text-white')
      } else if (this.isActive) {
        classes.push('border-2 border-green-600 text-green-500')
      } else {
        classes.push('border-2 border-gray-300 text-gray-500')
      }

      return classes
    },
    nameClass () {
      const classes = ['font-semibold mb-1 text-sm uppercase leading-none']

      if (this.isComplete) {
        classes.push('text-gray-700')
      } else if (this.isActive) {
        classes.push('text-green-600')
      } else {
        classes.push('text-gray-600')
      }

      return classes
    },
    lineClass () {
      const classes = ['o-step-line w-px mx-3 md:mx-4 border']

      if (this.isComplete) {
        classes.push('border-green-500')
      } else {
        classes.push('border-dashed border-gray-300')
      }

      return classes
    }
  }
}
</script>

<style>
.o-step:last-child .o-step-line {
  opacity: 0;
}
</style>
